/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrganizationCombos200ResponseItemsInner
 */
export interface GetOrganizationCombos200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    imageId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombos200ResponseItemsInner
     */
    hasSchedule: boolean;
}

/**
 * Check if a given object implements the GetOrganizationCombos200ResponseItemsInner interface.
 */
export function instanceOfGetOrganizationCombos200ResponseItemsInner(value: object): value is GetOrganizationCombos200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('hasSchedule' in value) || value['hasSchedule'] === undefined) return false;
    return true;
}

export function GetOrganizationCombos200ResponseItemsInnerFromJSON(json: any): GetOrganizationCombos200ResponseItemsInner {
    return GetOrganizationCombos200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetOrganizationCombos200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationCombos200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': json['position'],
        'enabled': json['enabled'],
        'deleted': json['deleted'],
        'organizationId': json['organizationId'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'price': json['price'],
        'hasSchedule': json['hasSchedule'],
    };
}

export function GetOrganizationCombos200ResponseItemsInnerToJSON(json: any): GetOrganizationCombos200ResponseItemsInner {
    return GetOrganizationCombos200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetOrganizationCombos200ResponseItemsInnerToJSONTyped(value?: GetOrganizationCombos200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'position': value['position'],
        'enabled': value['enabled'],
        'deleted': value['deleted'],
        'organizationId': value['organizationId'],
        'color': value['color'],
        'description': value['description'],
        'imageId': value['imageId'],
        'price': value['price'],
        'hasSchedule': value['hasSchedule'],
    };
}

